module.exports = "/lucky-balls/img/bonus_yellow/check_infoBar/check_013.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/check_infoBar/check_013.png
// module id = 958
// module chunks = 0